module.exports = __webpack_public_path__ + "img/brands-mulino-food.jpg?366abc4b7802056cab8ed9f88eb4e336";